import React from "react";
import MultiSelect from "../../../components/MultiSelect";

export const CATEGORIES = [
  { value: "GENERAL_COST", label: "GENERAL_COST", color: "bg-slate-100 text-slate-700 border border-slate-200" },
  { value: "VARIABLE_COST", label: "VARIABLE_COST", color: "bg-amber-100 text-amber-700 border border-amber-200" },
  { value: "DISBURSEMENT", label: "DISBURSEMENT", color: "bg-rose-100 text-rose-700 border border-rose-200" },
  { value: "TAXES", label: "TAXES", color: "bg-red-100 text-red-700 border border-red-200" },
  { value: "INCOME", label: "INCOME", color: "bg-green-100 text-green-700 border border-green-200" },
  { value: "CAPEX", label: "CAPEX", color: "bg-indigo-100 text-indigo-700 border border-indigo-200" },
  { value: "BANK_LOAN", label: "BANK_LOAN", color: "bg-violet-100 text-violet-700 border border-violet-200" },
  { value: "", label: "", color: "bg-gray-100 text-gray-500 border border-gray-200" },
];

const FALLBACK_COLOR = "bg-gray-100 text-gray-500 border border-gray-200";

export const CategoryPill = ({ value }) => {
  if (!value) return null;
  const match = CATEGORIES.find((c) => c.value.trim() === value.trim());
  const color = match?.color || FALLBACK_COLOR;
  return <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${color}`}>{value}</span>;
};

export default ({ values = [], onChange }) => {
  return <MultiSelect values={values} id="select-categories" options={CATEGORIES} onSelectedChange={onChange} placeholder="Select a category" />;
};
